<template>
  <!-- modelad -->
  <el-container class="allclassification">
    <!-- <el-header :height="'70'">
      <home-header :opacity="opacity"></home-header>
    </el-header> -->
    <el-main>
      <!-- <ad-search></ad-search> -->
      <!-- 分类 -->
      <!-- <div style="margin:10px auto;">
            <search-andselect></search-andselect>
          </div> -->
      <div class="main-top">
        <div style="margin:10px auto;width:1200px">
          <search-andselect></search-andselect>
        </div>
        <div class="classify">
          <div class="classify-left">
            <classify-nav :label="label"></classify-nav>
          </div>
          <div class="classify-right">
            <div class="classify-right-carousel">
              <el-carousel>
                <el-carousel-item
                  :id="'item' + index"
                  v-for="(item, index) in carousels"
                  :key="index"
                >
                  <a
                    :href="item.link_url"
                    class="allclassificationlink"
                  >
                    <img
                      :src="item.photo1"
                      alt=""
                    >
                    <p
                      v-text="item.title"
                      :title="item.title"
                    ></p>
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="classify-right-items">
              <div class="classify-right-item">
                <column-two
                  :top="themestop"
                  :bottom="themesbot"
                ></column-two>
              </div>
              <div class="classify-right-item">
                <column-two
                  :top="themestopScnd"
                  :bottom="themesbotScnd"
                ></column-two>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 热点活动 -->
      <div class="activity">
        <!-- <hotad :list="hotads"></hotad> -->
        <!-- <hot-topic :hot="hot"></hot-topic> -->
        <new-roll
          ref="new_roll"
          :label="labelroll"
        ></new-roll>
      </div>
    </el-main>
    <el-footer
      v-if="hidefooter"
      style="height:316px"
    >
      <home-footer></home-footer>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import homeFooter from "../components/homeFooter.vue"; //底部
import homeHeader from "../components/homeHeader.vue"; //头部
import homeHeaderAd from "../components/homeHeaderAd.vue"; //头部
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import searchAndselect from "../components/searchAndselect"; //搜索框
import adSearch from "../components/adSearch.vue";
// import titles from "../components/titles.vue"; //全部分类
import classifyNav from "../components/classifyNav.vue"; //全部分类
import columnTwo from "../components/columnTwo.vue"; //上下两个图片
import newRoll from "../components/newRoll.vue"; //最新滚动
import {
  getModuleInfo,
  newtitle,
  getModulStyle,
  newtitle1,
  getResource,
  getCategoryNode
} from "./../services/api.js";
import imgCard from "../components/imgCard.vue";
import hotTopic from "../components/hotTopic.vue"; //热门专题
import hotad from "../components/hotad.vue";

export default {
  data() {
    return {
      moduleIds: [1],
      titlelist: [],
      carousels: [],
      themestop: {},
      themesbot: {},
      themestopScnd: {},
      themesbotScnd: {},
      hot: {
        id: "",
        list: []
      },
      label: {
        id: "",
        list: []
      },
      labelroll: {
        id: "",
        list: [{ photo1: "", title: "" }]
      },
      hotads: [],
      opacity: "0.68"
    };
  },
  components: {
    homeFooter,
    homeHeader,
    classifyNav, //全部分类
    homeHeaderAd, //广告头
    homeFooterAd, //广告底
    adSearch, //带有广告位search
    columnTwo, //上下两个图片
    imgCard,
    hotTopic, //热门专题
    hotad,
    newRoll,
    searchAndselect
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.getTitles();
    this.getCarousel();
    this.getThems();
    this.getLabelNewRoll();
    // window.addEventListener("scroll", this.mosewheel, true);
  },
  watch: {
    channel_id() {
      this.getTitles();
      this.getCarousel();
      this.getThems();
      this.getLabelNewRoll();
    }
  },
  computed: {
    ...mapGetters([
      "webModels",
      "curModelInfo",
      "modelsInfo",
      "webID",
      "hidefooter"
    ]),
    channel_id() {
      return this.curModelInfo.id;
      // return this.modelsInfo.filter(item => item.tpl_id == 11)[0].id;
    }
  },
  methods: {
    async getHotsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    async getGroupsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },

    getThemeItem(data) {
      if (data.length > 1) {
        return data.shift();
      }
      return {};
    },

    getSpecialShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["1200x1060"]) {
          return item.group_custom_index_image["1200x1060"];
        }
      }
      return item.group_index_image;
    },
    getSpecialShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["1200x1060"]) {
          return item.custom_index_image["1200x1060"];
        }
      }
      return item.index_image;
    },
    getCarouselShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["1200x1060"]) {
          return item.custom_index_image["1200x1060"];
        }
      }
      return item.index_image;
    },
    getCarouselShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["1200x1060"]) {
          return item.group_custom_index_image["1200x1060"];
        }
      }
      return item.group_index_image;
    },
    ...mapActions(["setCurModelInfo", "setWebModels"]),
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    },
    getTitles() {
      //获取分类
      let totallist = [];
      newtitle({
        params: {
          customer_id: this.webID
        }
      }).then(res => {
        if (res) {
          if (res.status_code == 1) {
            var lis = res.data.list.filter(item => {
              return item.level == 1 && item.active == 1;
            });
            lis.forEach(item => {
              totallist.push({
                id: item.id,
                cname: item.cname,
                type: item.type
              });
            });
            newtitle1({
              params: {
                customer_id: this.webID
              }
            }).then(res => {
              if (res) {
                if (res.status_code == 1) {
                  var lis = res.data.list.filter(item => {
                    return item.level == 1 && item.active == 1;
                  });
                  lis.forEach(item => {
                    totallist.push({
                      id: item.id,
                      cname: item.cname,
                      type: item.type
                    });
                  });
                  this.label = {
                    id: 1,
                    list: totallist
                  };
                }
              }
            });
          }
        }
      });
    },
    getLabelNewRoll() {
      let data = {
        module_id: 1, //固定为16
        web_id: this.webID,
        sort: "asc", //2018年12月10日11:34:31 allclassnew最新滚动路由问题
        use_sort_num: 1, //2018年12月10日11:34:31 allclassnew最新滚动路由问题
        channel_id: this.channel_id // this.curModelInfo.id //频道id
      };
      getModuleInfo(data).then(res => {
        if (res.status_code == 1) {
          this.labelroll = {
            id: 1,
            list: res.data.list
          };
        }
      });
    },
    getCarousel() {
      //获取轮播图
      let data = {
        module_id: 16, //固定为16
        web_id: this.webID,
        use_sort_num: 1,
        channel_id: this.channel_id // this.curModelInfo.id //频道id
      };
      getModuleInfo(data).then(async res => {
        if (res.status_code == 1) {
          this.carousels = res.data.list;
          for (let i = 0; i < this.carousels.length; i++) {
            let resul = await this.getGroupsDataByCategoryChangeV(
              this.carousels[i]
            );
            this.carousels[i].photo1 = resul.photo1;
            this.carousels[i].link_url = resul.link_url;
            this.carousels[i].title = resul.title;
            this.$set(this.carousels, i, this.carousels[i]);
          }
        }
      });
    },
    getThems() {
      let data = {
        module_id: 19,
        web_id: this.webID,
        use_sort_num: 1,
        channel_id: this.channel_id //频道id
      };
      getModuleInfo(data).then(async res => {
        if (res.status_code == 1) {
          this.themestop = res.data.list.shift();
          let themestopresul = await this.getHotsDataByCategoryChangeV(
            this.themestop
          );
          this.themestop.photo1 = themestopresul.photo1;
          this.themestop.link_url = themestopresul.link_url;
          this.themestop.title = themestopresul.title;

          this.themesbot = res.data.list.shift();
          let themesbotresul = await this.getHotsDataByCategoryChangeV(
            this.themesbot
          );
          this.themesbot.photo1 = themesbotresul.photo1;
          this.themesbot.link_url = themesbotresul.link_url;
          this.themesbot.title = themesbotresul.title;

          this.themestopScnd = res.data.list.shift();
          let themestopScndresul = await this.getHotsDataByCategoryChangeV(
            this.themestopScnd
          );
          this.themestopScnd.photo1 = themestopScndresul.photo1;
          this.themestopScnd.link_url = themestopScndresul.link_url;
          this.themestopScnd.title = themestopScndresul.title;

          this.themesbotScnd = res.data.list.shift();
          let themesbotScndresul = await this.getHotsDataByCategoryChangeV(
            this.themesbotScnd
          );
          this.themesbotScnd.photo1 = themesbotScndresul.photo1;
          this.themesbotScnd.link_url = themesbotScndresul.link_url;
          this.themesbotScnd.title = themesbotScndresul.title;

          this.hot = {
            id: 19,
            list: res.data.list
          };
          for (let i = 0; i < this.hot.list.length; i++) {
            let resul = await this.getHotsDataByCategoryChangeV(
              this.hot.list[i]
            );
            this.hot.list[i].photo1 = resul.photo1;
            this.hot.list[i].link_url = resul.link_url;
            this.hot.list[i].title = resul.title;
            this.$set(this.hot.list, i, this.hot.list[i]);
          }
        }
      });
    }
  }
};
</script>
<style lang="less">
.allclassificationlink {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  p {
    position: absolute;
    width: calc(100% - 23px);
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    bottom: 0;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;
    padding: 18px 0px 18px 23px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.allclassification {
  // min-height: 100%;
  .el-main {
    width: 100%;
    padding: 0px;
    // margin: 0 auto;
    .main-top {
      width: 100%;
      background-color: #f7f7f7;
      padding: 10px 0px;
      margin-bottom: 30px;
      .classify {
        width: 1200px;
        margin: 0px auto;
        height: 442px;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        position: relative;
        .classify-left {
          // position: absolute;
          // left: 0px;
          // top: 0px;
          // bottom: 0px;
          width: 180px;
        }
        .classify-right {
          width: 1010px;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          .classify-right-carousel {
            width: 500px;
            height: 100%;

            .el-carousel__indicators {
              left: auto;
              right: 0;
              height: 56px;
              display: flex;
              align-items: center;
              .el-carousel__indicator {
                .el-carousel__button {
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                }
              }
            }
            .el-carousel {
              height: 100%;
              .el-carousel__container {
                height: 100%;
              }
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          .classify-right-items {
            width: 500px;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            .top {
              // height: 50%;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .classify-right-item {
              width: 245px;
            }
          }
        }
      }
    }

    .activity {
      // padding: 0px 30px;
      width: 1200px;
      margin: 0 auto;
    }
  }
  .el-footer {
    padding: 0px;
  }
}
</style>






// WEBPACK FOOTER //
// src/page/allClassification.vue